import { RichtextDisplay } from '../../teaching-notes/teaching-notes-drawer.style';
import {
  getRichtextValue,
  isRichtextValueEmpty,
} from '../../shared/logic/get-richtext-value';
import type { SuggestedAnswerFragment } from '../suggested-answers.graphql.generated';
import { SUGGESTED_ANSWER_BASE_RICHTEXT } from '../suggested-answer.constants';
import { useGetRichtextAnswer } from '../suggested-answer.hooks';

type Props = {
  id: string;
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
};

const SuggestedAnswerExampleRichtext = ({
  id,
  suggestedAnswerProperties,
}: Props) => {
  const answer = useGetRichtextAnswer({
    componentId: id,
    suggestedAnswerProperties,
  });

  return (
    !isRichtextValueEmpty(answer) && (
      <RichtextDisplay
        dangerouslySetInnerHTML={{
          __html: getRichtextValue(answer, SUGGESTED_ANSWER_BASE_RICHTEXT),
        }}
      />
    )
  );
};

export default SuggestedAnswerExampleRichtext;
